
import { useEffect } from "react";
import { LeadAccount } from "@/types/strategy-types";
import { useLeadAccountsLoader } from "./lead-accounts/useLeadAccountsLoader";
import { useLeadAccountOperations } from "./lead-accounts/useLeadAccountOperations";

export interface LeadAccountWithProvider extends LeadAccount {
  provider_name?: string;
}

export const useAdminLeadAccounts = () => {
  const { 
    leadAccounts, 
    loading, 
    loadLeadAccounts 
  } = useLeadAccountsLoader();
  
  const { 
    createLeadAccount, 
    updateLeadAccount, 
    deleteLeadAccount 
  } = useLeadAccountOperations(loadLeadAccounts);

  useEffect(() => {
    loadLeadAccounts();
  }, []);

  return {
    leadAccounts,
    loading,
    loadLeadAccounts,
    createLeadAccount,
    updateLeadAccount,
    deleteLeadAccount
  };
};
